import React from "react";
import { business } from "../../seo/business";

// Uses the hours-container styles from Home.css, which every page loads.
// `compact` uses short day names for narrow spaces like the footer.
const Hours = ({ compact }) => (
  <section className={compact ? "hours-container hours-compact" : "hours-container"}>
    {business.hours.map((row) => (
      <div className="day-and-hours" key={row.label}>
        <div className="days">{compact ? row.short : row.label}</div>
        <div className="hours">{row.display}</div>
      </div>
    ))}
  </section>
);

export default Hours;
